export default __webpack_public_path__ + "static/media/geslub_simbolo_version_principal.b8945994.png";